var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10000024512(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    y: 0.0361328,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9519 17.4738C23.2823 17.4738 25.1731 19.3646 25.1731 21.6951C25.1731 24.0255 23.212 25.9867 20.8815 25.9867C18.551 25.9867 16.6691 24.0959 16.6691 21.6951C16.6691 19.3646 18.5598 17.4738 20.9607 17.4738H20.9519ZM11.6475 29.179L13.1777 30.7092C13.6175 31.2193 14.4089 31.2896 14.919 30.8587L15.9391 30.0584C16.6691 30.4893 17.4605 30.8587 18.2608 31.0785L18.4103 32.3889C18.4807 33.0397 19.0611 33.5497 19.791 33.5497H21.9017C22.5524 33.5497 23.1328 33.11 23.212 32.3889L23.4319 31.1577C24.2321 30.9378 25.0324 30.5773 25.8327 30.1376L26.8528 30.9378C27.3629 31.3776 28.084 31.2984 28.5941 30.8675L30.1946 29.3373C30.6343 28.8272 30.6343 28.1061 30.265 27.596L29.3944 26.5055C29.7549 25.7756 30.1243 24.9753 30.3353 24.1751L31.716 24.1047C32.3756 23.9552 32.8857 23.3748 32.8857 22.724V20.543C32.8857 19.8922 32.446 19.303 31.7952 19.2327L30.2738 19.0832C30.0539 18.3533 29.7637 17.6321 29.4032 16.9726L30.3441 15.8117C30.7047 15.3016 30.7047 14.5014 30.2738 14.0704L28.7436 12.4699C28.2335 12.0302 27.5124 11.9598 27.0023 12.3995L25.8415 13.3493C25.1116 12.9096 24.4608 12.6194 23.6605 12.3995L23.511 10.8693C23.4406 10.2186 22.8602 9.7085 22.2007 9.7085H20.0197C19.2898 9.7085 18.7885 10.1482 18.7093 10.799L18.4895 12.25C17.6892 12.4699 16.8889 12.8305 16.159 13.1998L15.0685 12.3292C14.5584 11.8895 13.7582 11.9686 13.2481 12.3995L11.7179 13.9297C11.2782 14.3695 11.2078 15.1609 11.6475 15.671L12.5182 16.8318C12.0873 17.4826 11.7883 18.2829 11.5772 19.0832L10.1965 19.2327C9.53692 19.303 9.02686 19.8131 9.02686 20.543V22.724C9.02686 23.3748 9.46657 23.9552 10.1173 24.0343L11.498 24.1838C11.7179 24.9841 12.0081 25.7844 12.3687 26.4352L11.5684 27.4553C11.1375 27.9654 11.1375 28.7657 11.6475 29.2054V29.179Z",
    fill: "url(#paint0_linear_1352_1046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1046",
    x1: 20.9563,
    y1: 9.7085,
    x2: 21.3388,
    y2: 33.4354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD99E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF814B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10000024512);
export default __webpack_public_path__ + "static/media/Group-1000002451-2.47e05a7f1105703ba2a2eceef794019f.svg";
export { ForwardRef as ReactComponent };